export default "__VITE_ASSET__LR30aRQQ__"